import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import ReactToPrint from "react-to-print";

const componentRef = React.createRef();

class Certificado extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      linea: "________________________________________________________",
    };
  }

  //<Licencia modalLicencia=this.state.modalLicencia working=this.state.working licencia=this.state.licencia date=this.state.date/>
  render() {
    return (
      <Modal isOpen={this.props.modalLicencia} modalClassName="modal-message">
        <ModalHeader>
          <div>
            Certificado {this.props.certificado.folio_certificado}
            <button
              type="button"
              class="close"
              onClick={this.props.change}
              style={{ position: "fixed", right: "21%" }}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </ModalHeader>
        <ModalBody>
          <div className={this.props.working ? "" : "hide"}>
            <div className="progress-bar bg-orange progress-bar-striped progress-bar-animated">
              CARGANDO INFORMACIÓN
            </div>
          </div>

          <div className={this.props.working ? "hide" : ""}>
            <div
              className="row"
              ref={componentRef}
              style={{ background: "white" }}
            >
              {/*Aqui se muestra licencia******************************************************/}


            

              <form
                style={{
                  marginRight: "13%",
                  marginLeft: "13%",
                  color: "black",
                }}
              >
                <div style={{ textAlign: "left", margin: "3%" ,}} >
                  <table className="table">
                    <tbody>
                      <colgroup>
                        <col style={{ width: "50%" }}></col>
                        <col style={{ width: "50%" }}></col>
                      </colgroup>
                      <tr> {/* Logos IPSA */}
                        <td style={{ textAlign: "left", color:"black"}}>
                          <img
                            src="../assets/Escudo.jpg"
                            width="100"
                            height="100"
                          />
                        </td>
                        <td style={{ textAlign: "right", color:"black"}}>
                          <img
                            src="../assets/1631027847767_Logo IPSA.png"
                            width="200"
                            height="100"
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <table className="table">
                  <tbody>
                    <colgroup>
                      <col style={{ width: "70%" }}></col>
                      <col style={{ width: "30%" }}></col>
                    </colgroup>
                    <tr>
                      <td style={{ textAlign: "center", color:"black", verticalAlign:"middle"}}> 
                        {this.props.solicitud.tipo_certificado_id === "1" ? (
                          <h5 className="m-auto">
                            CERTIFICADO DE LIBRE VENTA No.{" "}
                            {this.props.certificado.folio_certificado}
                          </h5>
                        ) : (
                          <h5> 
                            CERTIFICADO DE PRODUCTO EXCLUSIVO PARA LA EXPORTACIÓN{" "}
                            {this.props.certificado.folio_certificado}
                          </h5>
                        )}
                      </td>
                      <td style={{ textAlign: "center", color:"black"}}>
                        <img src={`data:image/png;base64, ${this.props.certificado.qr}`}></img>
                      </td>
                    </tr>
                  </tbody>
                </table>
               
                {this.props.solicitud.tipo_certificado_id === "1" ? (
                  <p style={{ textAlign: "justify" }}>
                    La Dirección de Salud Animal del Instituto de Protección y
                    Sanidad Agropecuaria, a través del Departamento de
                    Regulación y Control de Insumos Pecuarios <b>CERTIFICA</b>{" "}
                    que el{" "}
                    {this.props.certificado.tpv_id <= 2 ||
                    this.props.certificado.tpv_id === 4
                      ? "medicamento veterinario "
                      : ""}
                    {this.props.certificado.tpv_id === 3 ? "producto afin" : ""}
                    {this.props.certificado.tpv_id === 5
                      ? "producto utilizado en alimentación animal"
                      : ""}
                    {this.props.certificado.nombre_comercial}, se encuentra
                    registrado bajo el No. {this.props.certificado.no_registro},
                    se comercializa en el país, de acuerdo a la Ley No.291.
                  </p>
                ) : (
                  <p style={{ textAlign: "justify" }}>
                    La Dirección de Salud Animal del Institutode Protección y
                    Sanidad Agropecuaria, de la República de Nicaragua a través
                    del Departamento de Regulación y Control de Insumos
                    Pecuarios, <b>CERTIFICA</b> que el producto veterinario:{" "}
                    {this.props.certificado.nombre_comercial}, no se
                    comercializa en el país y es exclusivo para su{" "}
                    <b>EXPORTACIÓN</b>, de acuerdo a las Leyes No. 291, 274, y
                    al RTCA 65.05.52:11.
                  </p>
                )}
                <div>
                  <br></br>
                  <br></br>
                  <h4>
                    <b>DATOS DEL PRODUCTO</b>
                  </h4>
                  <table className="table text-black" border="1">
                    <tbody>
                      {" "}
                      {/* empieza tabla */}
                      <colgroup>
                        <col style={{ width: "30%" }}></col>
                        <col style={{ width: "70%" }}></col>
                      </colgroup>
                      <tr>
                        <td style={{ border: "1px solid #000" }}>
                          <b>Nombre comercial:</b>
                        </td>
                        <td style={{ border: "1px solid #000" }}>
                          {this.props.certificado.nombre_comercial}
                        </td>
                      </tr>
                      <tr>
                        <td style={{ border: "1px solid #000" }}>
                          <b>Número de Registro Sanitario:</b>
                        </td>
                        <td style={{ border: "1px solid #000" }}>
                          {this.props.certificado.no_registro}
                        </td>
                      </tr>
                      <tr>
                        <td style={{ border: "1px solid #000" }}>
                          <b>Clasificación:</b>
                        </td>
                        <td style={{ border: "1px solid #000" }}>
                          {this.props.certificado.clasificacion ? this.props.certificado.clasificacion : "-"}
                        </td>
                      </tr>
                      <tr
                        className={
                          this.props.certificado.lista_principios_activos
                            .length > 0
                            ? ""
                            : "hide"
                        }
                      >
                        <td style={{ border: "1px solid #000" }}>
                          <b>Principio activo:</b>
                        </td>
                        <td style={{ border: "1px solid #000" }}>
                          {this.props.certificado.lista_principios_activos.map(
                            (activo) => (
                              <li>
                                {activo.principio_activo_name}{" "}
                                {activo.concentracion}{" "}
                                {activo.unidad_medida_name}
                              </li>
                            )
                          )}
                        </td>
                      </tr>
                      <tr
                        className={
                          this.props.certificado.lista_excipiente.length > 0
                            ? ""
                            : "hide"
                        }
                      >
                        <td style={{ border: "1px solid #000" }}>
                          <b>Excipientes:</b>
                        </td>
                        <td style={{ border: "1px solid #000" }}>
                          {this.props.certificado.lista_excipiente.map(
                            (excipiente) => (
                              <li>
                                {excipiente.excipiente_name}{" "}
                                {excipiente.concentracion}{" "}
                                {excipiente.unidad_medida_name}
                              </li>
                            )
                          )}
                        </td>
                      </tr>
                      <tr
                        className={
                          this.props.certificado.lista_composiciones_biologicas
                            .length > 0 && this.props.certificado.tpv_id === 3
                            ? ""
                            : "hide"
                        }
                      >
                        <td style={{ border: "1px solid #000" }}>
                          <b>Composición biológica:</b>
                        </td>
                        <td style={{ border: "1px solid #000" }}>
                          {this.props.certificado.lista_composiciones_biologicas.map(
                            (e) => (
                              <li>
                                {e.composicion_biologica_name}{" "}
                                {e.titulo_unidad_medida}
                              </li>
                            )
                          )}
                        </td>
                      </tr>
                      <tr
                        className={
                          this.props.certificado.lista_composiciones_quimicas
                            .length > 0 && this.props.certificado.tpv_id === 3
                            ? ""
                            : "hide"
                        }
                      >
                        <td style={{ border: "1px solid #000" }}>
                          <b>Composición química</b>
                        </td>
                        <td style={{ border: "1px solid #000" }}>
                          {this.props.certificado.lista_composiciones_quimicas.map(
                            (e) => (
                              <li>
                                {e.composicion_quimica_name} {e.concentracion}{" "}
                                {e.unidad_medida_name}
                              </li>
                            )
                          )}
                        </td>
                      </tr>
                      <tr
                        className={
                          this.props.certificado.lista_analisis.length > 0
                            ? ""
                            : "hide"
                        }
                      >
                        <td style={{ border: "1px solid #000" }}>
                          <b>Análisis garantizado</b>
                        </td>
                        <td style={{ border: "1px solid #000" }}>
                          {this.props.certificado.lista_analisis.map(
                            (analisis) => (
                              <li>
                                {analisis.analisis_name} {analisis.porcentaje}%
                              </li>
                            )
                          )}
                        </td>
                      </tr>
                      <tr>
                        <td style={{ border: "1px solid #000" }}>
                          <b>
                            {this.props.certificado.tpv_id <= 4
                              ? "Forma farmacéutica:"
                              : "Forma de comercialización:"}
                          </b>
                        </td>
                        <td style={{ border: "1px solid #000" }}>
                          {this.props.certificado.forma_farmaceutica}
                        </td>
                      </tr>
                      <tr>
                        <td style={{ border: "1px solid #000" }}>
                          <b>
                            {this.props.certificado.tpv_id <= 4
                              ? "Indicaciones de uso:"
                              : "Uso: "}
                          </b>
                        </td>
                        <td style={{ border: "1px solid #000" }}>
                          {this.props.certificado.tpv_id === 2
                            ? this.props.certificado.precauciones_uso
                            : this.props.certificado.uso}
                        </td>
                      </tr>
                      <tr
                        className={
                          (this.props.certificado.lista_especie_dosis.length >
                            0 && this.props.certificado.tpv_id <= 4 && this.props.solicitud.tipo_certificado_id === 1) || 
                            (this.props.solicitud.tipo_certificado_id === 2 && this.props.certificado.lista_analisis.length > 0)
                            ? ""
                            : "hide"
                        }
                      >
                        <td style={{ border: "1px solid #000" }}>
                          <b>Dosis:</b>
                        </td>
                        <td style={{ border: "1px solid #000" }}>
                          {this.props.certificado.lista_especie_dosis.map(
                            (e) => (
                              <li>
                                {" "}
                                {e.dosis} | {e.especie_name} - {e.categoria_name}
                              </li>
                            )
                          )}
                        </td>
                      </tr>
                      <tr
                        className={
                          this.props.certificado.lista_especie_dosis.length > 0
                            ? ""
                            : "hide"
                        }
                      >
                        <td style={{ border: "1px solid #000" }}>
                          <b> Especie destino:</b>
                        </td>
                        <td style={{ border: "1px solid #000" }}>
                          {this.props.certificado.lista_especie_dosis.map(
                            (e) => (
                              <li>
                                {" "}
                                {e.especie_name} - {e.categoria_name}
                              </li>
                            )
                          )}
                        </td>
                      </tr>
                      <tr
                        className={
                          this.props.certificado.lista_empaque.length > 0 &&
                          this.props.certificado.tpv_id !== 4
                            ? ""
                            : "hide"
                        }
                      >
                        <td style={{ border: "1px solid #000" }}>
                          <b>Presentación:</b>
                        </td>
                        <td style={{ border: "1px solid #000" }}>
                          {this.props.certificado.lista_empaque.map((e) => (
                            <li>
                              {" "}
                              {e.empaque_name} {e.presentacion_cantidad}{" "}
                              {e.presentacion_unidad_medida_name}
                            </li>
                          ))}
                        </td>
                      </tr>
                      <tr
                        className={
                          this.props.certificado.lista_presentaciones.length >
                            0 && this.props.certificado.tpv_id === 4
                            ? ""
                            : "hide"
                        }
                      >
                        <td style={{ border: "1px solid #000" }}>
                          <b>Presentación:</b>
                        </td>
                        <td style={{ border: "1px solid #000" }}>
                          {this.props.certificado.lista_presentaciones.map(
                            (e) => (
                              <li>
                                {" "}
                                {e.presentacion_name} {e.presentacion_cantidad}{" "}
                                {e.presentacion_unidad_medida}
                              </li>
                            )
                          )}
                        </td>
                      </tr>
                      <tr>
                        <td style={{ border: "1px solid #000" }}>
                          <b>Caducidad:</b>
                        </td>
                        <td style={{ border: "1px solid #000" }}>
                          {this.props.certificado.caducidad_producto}{" "}
                          {this.props.certificado.medida_tiempo}
                        </td>
                      </tr>
                      <tr
                        className={
                          this.props.certificado.lista_descarte.length > 0
                            ? ""
                            : "hide"
                        }
                      >
                        <td style={{ border: "1px solid #000" }}>
                          <b>Periodo de retiro:</b>
                        </td>
                        <td style={{ border: "1px solid #000" }}>
                            {this.props.certificado.lista_descarte.map((e) => (
                                <li>
                                  {e.especie_prod_name} {e.periodo}{" "}
                                  {e.medida_tiempo_name}
                                </li>
                              ))}
                        </td>
                      </tr>
                      <tr 
                        className={
                          this.props.certificado.precauciones_almacenamiento === null && this.props.certificado.precauciones_generales === null 
                            ? "hide"
                            : ""
                        }
                      >
                        <td style={{ border: "1px solid #000" }}>
                          <b>Precauciones y condiciones de almacenamiento:</b>
                        </td>
                        <td style={{ border: "1px solid #000" }}>
                          {this.props.certificado.tpv_id === 2 ||
                          this.props.certificado.tpv_id === 5
                            ? this.props.certificado.precauciones_almacenamiento
                            : this.props.certificado.precauciones_generales}
                        </td>
                      </tr>
                      <tr>
                        <td style={{ border: "1px solid #000" }}>
                          <b>Fecha de Registro:</b>
                        </td>
                        <td style={{ border: "1px solid #000" }}>
                          {this.props.certificado.fecha_registro}
                        </td>
                      </tr>
                      <tr>
                        <td style={{ border: "1px solid #000" }}>
                          <b>Vencimiento del Registro:</b>
                        </td>
                        <td style={{ border: "1px solid #000" }}>
                          {this.props.certificado.vigencia_registro}
                        </td>
                      </tr>
                      <tr>
                        <td style={{ border: "1px solid #000" }}>
                          <b>Condiciones de venta:</b>
                        </td>
                        <td style={{ border: "1px solid #000" }}>
                          {this.props.certificado.condiciones_venta} - El producto referido en el presente certificado, cuenta con autorización exclusivamente para la exportación y no se comercializa en la República de Nicaragua. El establecimiento fabricante se encuentra registrado y es inspeccionado por el IPSA como autoridad sanitaria competente. El producto es elaborado en cumplimiento de las Buenas Practicas de Manufactura (BPM)
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                
                  <br></br>
                  <br></br>
                  <h4>
                    <b>DATOS DEL FABRICANTE</b>
                  </h4>
                  <table className="table text-black" border="1">
                    <tbody>
                      {" "}
                      {/* empieza tabla */}
                      <colgroup>
                        <col style={{ width: "30%" }}></col>
                        <col style={{ width: "70%" }}></col>
                      </colgroup>
                      <tr>
                        <td style={{ border: "1px solid #000" }}>
                          <b>Razón Social:</b>
                        </td>
                        <td style={{ border: "1px solid #000" }}>
                        {this.props.certificado.fabricante.razon_social}
                        </td>
                      </tr>
                      <tr>
                        <td style={{ border: "1px solid #000" }}>
                          <b>Dirección:</b>
                        </td>
                        <td style={{ border: "1px solid #000" }}>
                        {this.props.certificado.fabricante.direccion}
                        </td>
                      </tr>
                      <tr>
                        <td style={{ border: "1px solid #000" }}>
                          <b>Código de establecimiento:</b>
                        </td>
                        <td style={{ border: "1px solid #000" }}>
                        {this.props.certificado.fabricante.folio_establecimiento}
                        </td>
                      </tr>
                      <tr>
                        <td style={{ border: "1px solid #000" }}>
                          <b>País de Origen:</b>
                        </td>
                        <td style={{ border: "1px solid #000" }}>
                        {this.props.certificado.fabricante.pais_texto !== null
                      ? this.props.certificado.fabricante.pais_texto
                      : "NICARAGUA"}{" "}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  

                
                  <br></br>
                  <br></br>

                  <h4>
                    <b>DATOS DEL TITULAR DEL REGISTRO</b>
                  </h4>
                  <table className="table text-black" border="1">
                    <tbody>
                      {" "}
                      {/* empieza tabla */}
                      <colgroup>
                        <col style={{ width: "30% !important" }}></col>
                        <col style={{ width: "70%" }}></col>
                      </colgroup>
                      <tr>
                        <td style={{ border: "1px solid #000" }}>
                          <b>Razón Social:</b>
                        </td>
                        <td style={{ border: "1px solid #000" }}>
                        {this.props.certificado.titular.razon_social}
                        </td>
                      </tr>
                      <tr>
                        <td style={{ border: "1px solid #000" }}>
                          <b>Dirección:</b>
                        </td>
                        <td style={{ border: "1px solid #000" }}>
                        {this.props.certificado.titular.direccion}
                        </td>
                      </tr>
                      <tr>
                        <td style={{ border: "1px solid #000" }}>
                          <b>Código de establecimiento:</b>
                        </td>
                        <td style={{ border: "1px solid #000" }}>
                        {this.props.certificado.titular.folio_establecimiento}
                        </td>
                      </tr>
                      <tr>
                        <td style={{ border: "1px solid #000" }}>
                          <b>País de Origen:</b>
                        </td>
                        <td style={{ border: "1px solid #000" }}>
                        {this.props.certificado.titular.pais_texto !== null
                      ? this.props.certificado.titular.pais_texto
                      : "NICARAGUA"}{" "}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                 

                <br></br>
                <br></br>

                {this.props.solicitud.tipo_certificado_id === "1" ? (
                  <p>
                    Se extiende el presente documento el cual tiene una vigencia
                    de un año apartir de su fecha de emisión. Dado en la ciudad
                    de Managua, Nicaragua a {this.props.date}.
                    {/* los XXX días del mes de XXXXX del año XXXXXXXXXXX */}
                    {/* El registro sanitario de este producto tiene vigencia de {this.props.solicitud.fecha_solicitud} al {this.props.solicitud.fecha_vecimiento} siempre y

                       cuando se encuentre en cumplimiento  de la Legislación Nacional Vigente en la República de Nicaragua. */}
                  </p>
                ) : (
                  <p>
                    El presente documento tiene una vigencia de 2 años a partir
                    de la fecha de su emisión. Dato en la ciudad de Managua,
                    Nicaragua a {this.props.date}.
                    {/* los veintiocho días del mes de mayo del año dos mil dieciocho. */}{" "}
                    {/* CAMBIAR FECHA DATE TO STRING */}
                  </p>
                )}

                {/*   <p><b>Managua, Nicaragua</b>{" "} {this.props.date}</p> */}

                <p
                  style={{
                    textAlign: "center",
                    margin: "8%",
                    marginTop: "15em",
                  }}
                >
                  <center>
                    <div
                      style={{ borderBottom: "1px solid #333", width: "50%" }}
                    >
                      {this.props.solicitud.nombre_firma}
                    </div>
                  </center>
                  <br></br> Director de Salud Animal
                </p>

                {/*<p style={{ textAlign: "center", margin: "8%", marginTop:"15em" }}>{this.state.linea}<br></br> Jefe Departamento Regulación y Control de Insumos Precuarios </p>*/}
              </form>
            </div>
            <hr />
          </div>
        </ModalBody>
        <ModalFooter>
          <ReactToPrint
            content={() => componentRef.current}
            pageStyle=""
            trigger={() => (
              <button id="btn-imprimir" className="btn btn-primary m-r-5">
                Imprimir
              </button>
            )}
            onBeforeGetContent={() =>
              this.props.imprimir(this.props.id_detalleP_notificar)
            }
          />
          <button className="btn btn-danger" onClick={this.props.change}>
            Regresar
          </button>
        </ModalFooter>
      </Modal>
    );
  }
}
export default Certificado;
